import { html as l, when as e } from "@microsoft/fast-element";
const o = l`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.5048 9.98547C17.4971 9.97707 17.4892 9.9688 17.481 9.96067L11.2763 3.77498C10.5739 3.07467 9.43667 3.07554 8.73409 3.77438L2.47045 10.0195C2.2911 10.1983 2.22115 10.4454 2.26072 10.6774V19.954C2.26072 20.9478 3.06872 21.75 4.05992 21.75H15.9508C16.942 21.75 17.75 20.9478 17.75 19.954V10.5402C17.75 10.3204 17.6554 10.1226 17.5048 9.98547Z"
      fill="currentColor"
    />
    <path
      d="M13.7818 4.15472L14.7351 3.22263C15.3415 2.63119 16.317 2.63035 16.9235 3.22322L21.6809 7.8742C21.6891 7.88215 21.697 7.89024 21.7047 7.89846C21.8583 8.0358 21.9551 8.23552 21.9551 8.45784V15.5526C21.9551 16.4179 21.2419 17.0909 20.3987 17.0909H19.25V10.5402C19.25 9.90528 18.9853 9.33024 18.5643 8.9229L18.5401 8.8984L13.7818 4.15472Z"
      fill="currentColor"
    />
  </svg>
`, t = l`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.01072 10.5402V19.954C3.01072 20.5314 3.48076 21 4.05992 21H7.90697M12.1038 21H15.9508C16.53 21 17 20.5314 17 19.954V10.5402M6.50804 21H14.2021M3 10.5506L5.08767 8.46913L9.263 4.30612C9.67335 3.89796 10.3374 3.89796 10.7468 4.30612L16.9515 10.4918"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.7825 4.29641L15.7826 4.29627C15.793 4.28621 15.8084 4.27881 15.8293 4.27881C15.8502 4.27881 15.8651 4.28624 15.8749 4.29582L20.4551 8.77348V15.5526C20.4551 15.5566 20.4544 15.5591 20.4534 15.5614C20.4521 15.5643 20.4495 15.5688 20.4445 15.5737C20.4346 15.5833 20.4197 15.5909 20.3987 15.5909H19.0548H17.4421H17.202L17.077 17.0909H17.4421H19.0548H20.3987C21.2419 17.0909 21.9551 16.4179 21.9551 15.5526V8.45784C21.9551 8.23552 21.8583 8.0358 21.7047 7.89846C21.697 7.89024 21.6891 7.88215 21.6809 7.8742L16.9235 3.22322C16.317 2.63035 15.3415 2.63119 14.7351 3.22263L14.7345 3.22325L12.1888 5.71219L13.2496 6.77292L15.7825 4.29641Z"
      fill="currentColor"
    />
  </svg>
`, r = l`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.18756 3.05929L7.18562 3.06124L1.97045 8.261C1.79393 8.43701 1.72338 8.67909 1.75894 8.9079V16.6283C1.75894 17.0807 1.94566 17.4925 2.24794 17.7879C2.54115 18.0739 2.94214 18.2499 3.38324 18.2499C3.38324 18.2499 3.38325 18.2499 3.38324 18.2499H13.2923C13.2923 18.2499 13.2923 18.2499 13.2923 18.2499C13.4516 18.2499 13.6057 18.227 13.7513 18.1842C14.4237 17.9866 14.9166 17.366 14.9166 16.6283L14.9167 8.7834C14.9167 8.56564 14.8239 8.36956 14.6756 8.23254C14.6692 8.22559 14.6625 8.21872 14.6558 8.21196L9.48515 3.05721C9.2051 2.77802 8.84855 2.62227 8.48307 2.58971C8.35393 2.5782 8.22368 2.58208 8.09529 2.60132C7.76505 2.65081 7.44715 2.80197 7.19229 3.05459L7.18954 3.05732L7.18756 3.05929Z"
      fill="currentColor"
    />
    <path
      d="M16.4167 14.3674H16.9989C17.768 14.3674 18.4209 13.7533 18.4209 12.9605V7.0482C18.4209 6.82791 18.3259 6.6298 18.1747 6.49258C18.1682 6.48578 18.1616 6.47906 18.1548 6.47245L14.1903 2.59664C13.6363 2.05503 12.7458 2.05588 12.192 2.59604L11.6645 3.11179L15.7148 7.14967L15.7352 7.17025C16.1537 7.57733 16.4167 8.15071 16.4167 8.7834V14.3674Z"
      fill="currentColor"
    />
  </svg>
`, n = l`
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.74995 2.44734L5.7484 2.4489L1.57627 6.60871C1.43504 6.74951 1.37861 6.94317 1.40705 7.12622V13.3025C1.40705 13.6645 1.55643 13.9939 1.79825 14.2302C2.03282 14.459 2.35361 14.5998 2.7065 14.5998C2.70649 14.5998 2.7065 14.5998 2.7065 14.5998H10.6338C10.6337 14.5998 10.6338 14.5998 10.6338 14.5998C10.7612 14.5998 10.8844 14.5815 11.0009 14.5472C11.5388 14.3892 11.9332 13.8927 11.9332 13.3025L11.9332 7.02662C11.9332 6.85242 11.859 6.69555 11.7404 6.58594C11.7352 6.58037 11.7299 6.57488 11.7245 6.56947L7.58803 2.44567C7.36398 2.22231 7.07875 2.09772 6.78636 2.07167C6.68305 2.06246 6.57885 2.06556 6.47613 2.08096C6.21194 2.12055 5.95762 2.24148 5.75374 2.44357L5.75153 2.44576L5.74995 2.44734Z"
      fill="currentColor"
    />
    <path
      d="M13.1332 11.4939H13.5991C14.2143 11.4939 14.7366 11.0025 14.7366 10.3683V5.63846C14.7366 5.46223 14.6606 5.30374 14.5397 5.19397C14.5345 5.18852 14.5292 5.18315 14.5238 5.17786L11.3521 2.07721C10.9089 1.64393 10.1965 1.6446 9.75351 2.07673L9.33151 2.48934L12.5717 5.71964L12.588 5.7361C12.9229 6.06176 13.1332 6.52047 13.1332 7.02662V11.4939Z"
      fill="currentColor"
    />
  </svg>
`, i = l`
  ${e((C) => C._type === "outline", t)}
  ${e((C) => C._type === "solid", o)}
  ${e((C) => C._type === "mini", r)}
  ${e((C) => C._type === "micro", n)}
`;
export {
  i as homeStackedTemplate
};
